import { getApiV1ThreeLetterCodePartnerAdminsGroups } from '@fukuri-admins/apis/client/gen/endpoints';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';

type GroupOption = {
  label: string;
  value: number;
};

export async function getGroups(): Promise<GroupOption[]> {
  const threeLetterCode = getThreeLetterCode();
  const data = await getApiV1ThreeLetterCodePartnerAdminsGroups(threeLetterCode);
  return data.groups.map(group => ({
    label: group.name,
    value: group.id,
  }));
}
